import React from "react";
import "../../Styles/yellowcalf.css/NewRecharge.css";

function NewRecharge() {
  return (
    <div className="newrecharge-container" style={{ paddingTop: "25px" }}>
      <div className="newrecharge-row">
        <div className="newrecharge-col">
          <div className="newrecharge-panel">
            <div className="newrecharge-panel-body">
              <div className="newrecharge-customer-section">
                <h3 className="newrecharge-main-title">New Recharge</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="newrecharge-row">
        <div className="newrecharge-col">
          <div className="newrecharge-panel">

            <div className="newrecharge-panel-body">
              <div className="newrecharge-user-section">
                <div className="newrecharge-user-form">
                  <div className="newrecharge-row">
                    <form id="rechargeForm">
                      <div className="newrecharge-row newrecharge-mb-3">
                        {/* Student Dropdown */}
                        <div className="newrecharge-col-half">
                          <label className="newrecharge-label">
                            Wallet Recharge Student Id{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <select className="newrecharge-form-control" required>
                            <option value="">Select Student</option>
                            <option value="53">Sana (12305)</option>
                            <option value="24">Pratik (AN131)</option>
                            <option value="29">Vrishali (AN137)</option>
                            <option value="32">Jyoti (A1234)</option>
                            <option value="20">Sanjana (AN127)</option>
                            <option value="35">Jenny (88515145)</option>
                            <option value="37">Rukmini (DEV123)</option>
                          </select>
                        </div>

                        {/* Amount */}
                        <div className="newrecharge-col-half">
                          <label className="newrecharge-label">
                            Amount <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            className="newrecharge-form-control"
                            placeholder="Enter amount"
                            required
                          />
                        </div>
                      </div>

                      <div className="newrecharge-row newrecharge-mb-3">
                        {/* Reference No */}
                        <div className="newrecharge-col-half">
                          <label className="newrecharge-label">
                            Reference No <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="newrecharge-form-control"
                            placeholder="Enter reference number"
                            required
                          />
                        </div>

                        {/* Recharge Mode */}
                        <div className="newrecharge-col-half">
                          <label className="newrecharge-label">
                            Recharge Mode{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <select className="newrecharge-form-control" required>
                            <option value="">Select</option>
                            <option value="by cash">By Cash</option>
                            <option value="by cheque">By Cheque</option>
                            <option value="cash transfer">Cash Transfer</option>
                            <option value="paypal">Paypal</option>
                            <option value="paytm">PayTM</option>
                            <option value="mpesa_manual">Mpesa</option>
                          </select>
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="newrecharge-text-end newrecharge-mt-4">
                        <button
                          type="submit"
                          className="newrecharge-btn newrecharge-btn-success"
                        >
                          Recharge
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewRecharge;
